import lodash from 'lodash'
import moment from 'moment'
import { cacheTime } from '../../../../utils/constant'
import { filter } from '../../../../utils/search'
import Base, { criteriaIgnore } from '../base.store'

const baseUrl = '/api/v1/security/roles'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {
        listIsDefaultFalse: [],
        cacheDate: {
            listIsDefaultFalse: null
        }
    }),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        companySave(context, { data, config }) {
            return base.request.put(`${baseUrl}/company`, data, { ...config });
        },
        companySearch(context, { criteria, config }) {
            criteria = lodash.cloneDeepWith(criteria, (value, key) => {
                if (criteriaIgnore.includes(key)) {
                    return null;
                }
            });
            return base.request.post(`${baseUrl}/company/_search`, criteria, { ...config });
        },
        cacheFindAllIsDefaultFalse(context, { searchQuery }) {
            let force = false;
            const cacheDateResult = context.state.cacheDate.listIsDefaultFalse;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true
            }
            const where = [
                { name: 'name', operator: 'like', value: searchQuery },
                { logic: 'OR', name: 'desc', operator: 'like', value: searchQuery }
            ]
            const sort = [{ name: 'name', type: 'asc' }]
            const list = context.state.listIsDefaultFalse || []
            if (list.length > 0 && !force) {
                return filter({ list, where, sort })
            }
            return context.dispatch('findAllIsDefaultFalse', {})
                .then(list => filter({ list, where, sort }))
        },
        findAllIsDefaultFalse(context, { criteria, config }) {
            criteria = lodash.merge({
                select: ['**'],
                page: 0,
                size: 1000000,
                sort: [{ name: "name", type: "ASC" }],
                where: [
                    { name: "isActive", type: "Boolean", operator: '=', value: true },
                    { name: "isDefault", type: 'Boolean', operator: '=', value: false }
                ],
            }, criteria)
            return context.dispatch('search', { criteria, config })
                .then(page => {
                    const list = page.data
                    context.commit('setListIsDefaultFalse', { list })
                    return list
                });
        }
    },
    mutations: {
        ...base.mutations,
        setListIsDefaultFalse(state, { list }) {
            state.listIsDefaultFalse = list
            state.cacheDate.listIsDefaultFalse = moment().add(cacheTime, 'ms')
        },
    },
}
